import 'core-js/modules/es6.object.keys.js';
import 'core-js/modules/es6.symbol.js';
import 'core-js/modules/es6.array.filter.js';
import 'core-js/modules/es6.object.get-own-property-descriptor.js';
import 'core-js/modules/es7.object.get-own-property-descriptors.js';
import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _styled from '@emotion/styled-base';
import React__default from 'react';
import { intentPrimary, borderRadiusSmall, intentPrimaryHover, intentPrimaryActive } from '../theme/theme.js';
import { Icon } from '@blueprintjs/core';

var _excluded = ["href", "text", "icon", "iconRight", "as", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Link = /*#__PURE__*/_styled("a", {
  target: "ee4gbcy0"
})("color:", intentPrimary, ";text-decoration:none;border-radius:", borderRadiusSmall, ";&:hover{color:", intentPrimaryHover, ";text-decoration:underline;}&:active{color:", intentPrimaryActive, ";text-decoration:underline;}.bp3-icon:first-of-type{margin-right:0.5rem;}.bp3-icon:last-child{margin-left:0.5rem;}");

function HTMLLink(_ref, ref) {
  var href = _ref.href,
      text = _ref.text,
      icon = _ref.icon,
      iconRight = _ref.iconRight,
      as = _ref.as,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var linkProps = as ? _objectSpread({
    as: as
  }, otherProps) : _objectSpread({
    href: href
  }, otherProps);
  return /*#__PURE__*/React__default.createElement(Link, _extends({
    ref: ref
  }, linkProps), icon ? iconRight ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, text !== null && text !== void 0 ? text : children), /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
    icon: icon
  }), /*#__PURE__*/React__default.createElement("span", null, text !== null && text !== void 0 ? text : children)) : text !== null && text !== void 0 ? text : children);
}

var HTMLLink$1 = /*#__PURE__*/React__default.forwardRef(HTMLLink);

export { HTMLLink$1 as default };
//# sourceMappingURL=html-link.js.map
